import { render, staticRenderFns } from "./panic-withdraw.vue?vue&type=template&id=1db81c88&scoped=true&"
import script from "./panic-withdraw.vue?vue&type=script&lang=js&"
export * from "./panic-withdraw.vue?vue&type=script&lang=js&"
import style0 from "./panic-withdraw.vue?vue&type=style&index=0&lang=less&"
import style1 from "./panic-withdraw.vue?vue&type=style&index=1&id=1db81c88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db81c88",
  null
  
)

export default component.exports